module.exports = __webpack_public_path__ + "stylesheets/landing-template_49b575c1f69f6b5ecdedd6720adb65f1.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/landing-template.less
// module id = dy9G
// module chunks = 154